module.exports = {
    'Init': require('./init'),
    'InsertResults': require('./insert-results'),
    'Pagination': require('./pagination'),
    'Search': require('./search'),
    'ShowMore': require('./showMore'),
    'ToggleModuleVisibility': require('./toggle-module-visibility')
};